import axios from '@/api/axios';
import { AxiosRequestConfig } from 'axios';

class ApiBase {
  private url: string;

  constructor() {
    /**Base url. For live env will use relative url*/
    this.url = import.meta.env.VITE_API_BASE_URL;
  }

  async get<T = any>(url: string, config?: AxiosRequestConfig) {
    return axios.get<T>(url, config);
  }

  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    return axios.post<T>(url, data, config);
  }

  async put<T = any>(url: string, data?: any, config = {}) {
    return axios.put<T>(url, data, config);
  }

  async patch<T = any>(url: string, data?: any, config = {}) {
    return axios.patch<T>(url, data, config);
  }

  async delete<T = any>(url: string, config?: AxiosRequestConfig) {
    return axios.delete<T>(url, config);
  }
}

const AxiosService = new ApiBase();

export default AxiosService;
